import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { catchError, combineLatest, finalize, of, tap } from 'rxjs';
import { Activity } from 'src/app/model/Avtivity';
import { PresenceDTO } from 'src/app/modules/agenda/components/models/presence.model';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

@Component({
  selector: 'app-activity-qrcode-confirmation-form',
  templateUrl: './activity-qrcode-confirmation-form.component.html',
  styleUrls: ['./activity-qrcode-confirmation-form.component.css'],
})
export class ActivityQrcodeConfirmationFormComponent implements OnInit {
  emailForm!: FormGroup;
  idActivity!: number;
  activity!: Activity;
  isLoading: boolean = true;
  isCalled: boolean = false;
  error: boolean = false;
  notIn: boolean = false;
  showSpinner = false;
  isSubmitting: boolean = false;
  session: boolean = true;
  alreadyPresent: boolean = false;
  listAlReadyPresent: string[] = [];

  // Exemple dynamique

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private service: AuthService,
    private spinnerService: SpinnerServiceService,
  ) {
    this.idActivity = +this.route.snapshot.params['idActivity'];
  }

  ngOnInit(): void {
    this.spinnerService.showSpinner();
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
    console.log('id : ', this.idActivity);
    this.getActivityData(this.idActivity);
  }

  get emailControl() {
    return this.emailForm.get('email')!;
  }

  confirmPresence() {
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      console.log('form : ', this.emailForm.value);
    } else {
      this.isSubmitting = true;
      this.emailForm.disable();
      const email = this.emailForm.value.email;
      console.log('Email confirmé :', email);
      const presenceInfo = new PresenceDTO(email, '', this.idActivity);
      console.log('dto : ', presenceInfo);
      this.showSpinner = true;
      //Check Presence
      if (this.containsEmail(this.listAlReadyPresent, email)) {
        this.alreadyPresent = true;
        console.log('Email trouvé ✅');
      } else {
        console.log('Email non trouvé X');

        this.alreadyPresent = false;
        this.service
          .setParticipantPresenceQrCode(presenceInfo)
          .pipe(
            tap((response) => {
              this.spinnerService.hideSpinner();
              console.log('La reponse : ', response);
              this.showSpinner = false;
              if (response) {
                this.isCalled = true;
              } else {
                this.notIn = true;
                this.emailForm.enable();
                // this.isSubmitting = false;
              }
            }),
            catchError((error) => {
              console.error('Erreur Serveur : ', error);
              this.isCalled = false;
              this.error = true;

              return of(null);
            }),
            finalize(() => {
              // 🔁 exécuté dans tous les cas
              this.isSubmitting = false;
            }),
          )
          .subscribe();
      }
    }

    // 👉 appel backend ici
  }
  getActivityData(id: number) {
    const activity$ = this.service.getActivityById(id);
    const list$ = this.service.getAllPresentInSingleActivity(id);

    combineLatest([activity$, list$])
      .pipe(
        tap(([activity, listEmails]) => {
          // Les donnees de l'activites
          console.log('Activite : ', activity);
          const dateNow = new Date();
          const closeDate = new Date(activity.closeDate);

          // Normalisation à minuit UTC
          const todayUTC = new Date(
            Date.UTC(
              dateNow.getUTCFullYear(),
              dateNow.getUTCMonth(),
              dateNow.getUTCDate(),
            ),
          );

          const closeUTC = new Date(
            Date.UTC(
              closeDate.getUTCFullYear(),
              closeDate.getUTCMonth(),
              closeDate.getUTCDate(),
            ),
          );

          if (
            closeUTC.getTime() > todayUTC.getTime() ||
            closeUTC.getTime() == todayUTC.getTime()
          ) {
            this.session = true;
          } else if (closeDate.getTime() < todayUTC.getTime()) {
            this.session = false;
          }

          this.spinnerService.hideSpinner();
          this.isLoading = false;
          this.activity = activity;

          //La liste

          console.log('list des personnes deja present : ', listEmails);
          this.listAlReadyPresent = listEmails;
          console.log('liste apres affectation : ', this.listAlReadyPresent);
        }),
      )

      .subscribe();
  }

  containsEmail(emails: string[], emailToFind: string): boolean {
    return emails.some(
      (email) => email.toLowerCase() === emailToFind.toLowerCase(),
    );
  }
}
